/**
 * Parse a comma-separated count string (e.g. "1,234") into a number.
 * Returns null if the value is missing or not a valid number.
 */
export function parseStarCount(value: string | number | null | undefined): number | null {
  if (value == null || value === '') return null

  const normalized = typeof value === 'number' ? String(value) : value
  const parsed = Number(normalized.replaceAll(',', ''))
  return Number.isNaN(parsed) ? null : parsed
}
